import React from "react";

const CourseSidebar = ({
  courses,
  onChapterSelect,
  onPageSelect,
  onAddChapter,
  onAddPage,
  selectedChapter,
  selectedPage,
}) => {
  return (
    <div className="col-md-4">
      <h3>Manage Chapters & Pages</h3>
      <ul className="list-group">
        {courses.map((course) => (
          <li key={course.id} className="list-group-item">
            <strong>{course.course_name}</strong>
            <button
              onClick={() => onAddChapter(course.id)}
              className="btn btn-sm btn-primary"
              style={{ marginLeft: "10px" }}
            >
              + Add Chapter
            </button>
            <ul style={{ marginTop: "10px" }}>
              {course.chapters.map((chapter) => (
                <li key={chapter.id} style={{ marginBottom: "10px" }}>
                  <span
                    onClick={() => onChapterSelect(chapter)}
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      display: "inline-block",
                      marginRight: "10px",
                      color: selectedChapter?.id === chapter.id ? "#05ACEC" : "black",
                    }}
                  >
                    {chapter.chapter_name}
                  </span>
                  <button
                    onClick={() => onAddPage(chapter.id)}
                    className="btn btn-sm btn-secondary"
                  >
                    + Add Page
                  </button>
                  <ul style={{ marginTop: "5px" }}>
                    {chapter.pages.map((page) => (
                      <li
                        key={page.id}
                        onClick={() => onPageSelect(page)}
                        style={{
                          cursor: "pointer",
                          marginLeft: "15px",
                          marginBottom: "5px",
                          color: selectedPage?.id === page.id ? "#05ACEC" : "black",
                        }}
                      >
                        {page.title}
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CourseSidebar;